import { CheckHouseholdReferencesResponse, CheckCohortHouseholdsRequest } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { ValidHouseholdRequest, VerifiedHouseholdReferences } from '../../types/forms.type';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class PostValidHouseholds extends BaseAdapter<CheckHouseholdReferencesResponse> implements AdapterInterface {
  rawResponse: CheckHouseholdReferencesResponse;

  modifiedRequest: CheckCohortHouseholdsRequest;

  async adaptResponse(request: ValidHouseholdRequest): Promise<VerifiedHouseholdReferences> {
    const formattedRequest = this.adaptRequest(request);

    await this.fetchApiResponse('/api/check-households', HTTPMethod.Post, formattedRequest);

    return {
      validHouseholds: this.rawResponse.valid_household_references,
      invalidHouseholds: this.rawResponse.invalid_household_references,
    };
  }

  adaptRequest(request: ValidHouseholdRequest): CheckCohortHouseholdsRequest {
    this.modifiedRequest = {
      household_references: request.selectedHouseholds,
      scope: {
        start_snapshot: request.startSnapshot,
        end_snapshot: request.endSnapshot,
      },
    };
    return this.modifiedRequest;
  }
}
